import { Record } from "immutable";

export class AccountStatementRecord extends Record ({
    id: null,
    op_date: null,
    description: null,
    debit: null,
    credit: null,
    type: null,
    repaid_date: null,
    invoice_date: null,
    due_date: null,
    outstanding: null
}) {}

export class AccountSummaryRecord extends Record ({
    sanction_limit: null,
    throughput: null,
    peak_limit: null, 
    loaded_limit: null, 
    utilized_limit: null, 
    available_limit: null, 
    total_paid: null, 
    cashback_earned: null,
}) {}